import _ from "lodash";
import api from "@/api";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getReportUrl(
      // eslint-disable-next-line no-unused-vars
      { commit },
      {
        start_date,
        end_date,
        types,
        exclude_type_combinations,
        states,
        account_id,
        internal_mode
      }
    ) {
      // eslint-disable-next-line no-useless-catch
      try {
        const params = { start_date, end_date };

        if (types && types.length) {
          params.types = types;
          // GET query params are always strings; Laravel's `boolean` rule
          // accepts "1"/"0" but not the literal strings "true"/"false" that
          // axios would produce from a raw JS boolean here.
          params.exclude_type_combinations = exclude_type_combinations
            ? "1"
            : "0";
        }

        if (states && states.length) {
          params.states = states;
        }

        // Only sent by PZSE staff, who pick which client's report to view -
        // client/vendor callers are always forced to their own account
        // server-side regardless of what's sent here.
        if (account_id) {
          params.account_id = account_id;
          params.internal_mode = internal_mode ? "1" : "0";
        }

        const response = await api.get("/sla-dashboard/report-url", {
          params
        });

        return _.get(response, "data.result.url", null);
      } catch (error) {
        throw error;
      }
    }
  }
};
